import { h } from 'preact';
import NewsHeader from './news_header';
import { createDestinationLogoByName } from './shared/svg/logos';
import { BuzzFeedNewsBrandLogo } from './shared/svg/brands/news';
import { CloseIcon } from './shared/svg/icons/close';
import { DefaultUserIcon } from './shared/svg/icons/default-user';
import { HamburgerIcon } from './shared/svg/icons/hamburger';
import { createBrandLogoByName, createBrandTaglineByName } from './shared/svg/brands';

export const headerContainerId = 'js-header-container';

const SVGDefs = ({ children }) => (
  // https://stackoverflow.com/questions/40562818/gradients-hidden-using-svg-symbols
  <svg width="0" height="0" style="display: block;">
    <defs>{ children }</defs>
  </svg>
);

/**
 * This container is used by the client to remount the application instance.
 * It is diffed against shadow DOM tree reconstructed on the client side.
 * Be wary of changing its contents as it may affect initialisation process.
*/
const HeaderContainer = ({ ...props }) => (
  <div id={headerContainerId}>
    <NewsHeader {...props} />
  </div>
);

/**
 * Provides a shell for the header component, which is only rendered on the server.
 * Any static data referenced from the client code belongs here (i.e. JS globals or SVG definitions)
*/
const HeaderShell = (props) => {
  const { navItems = {}, brand } = props;
  const { destinations = [] } = navItems;
  return (
    <div>
      <SVGDefs>
        {destinations.map(({ name }) => createDestinationLogoByName(name))}
        {createBrandLogoByName(brand)}
        {createBrandTaglineByName(brand)}
        <CloseIcon />
        <DefaultUserIcon />
        <BuzzFeedNewsBrandLogo />
        <HamburgerIcon />
      </SVGDefs>
      <HeaderContainer {...props} />
      <script dangerouslySetInnerHTML={{ __html: `
      window.BZFD = window.BZFD || {};
      window.BZFD.Config = window.BZFD.Config || {};
      window.BZFD.Config.bfwInfoCookie = 'bf2-b_info';
      window.BZFD.__HEADER_STATE__ = ${JSON.stringify(props)};
    ` }} />
    </div>
  );
};

export default HeaderShell;
